import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-insurance-service-type',
  templateUrl: './dialog-insurance-service-type.component.html',
  styleUrls: ['./dialog-insurance-service-type.component.scss'],
})
export class DialogInsuranceServiceTypeComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
